export const EXCMAGREEMENTCONSENT_DELETE_RESET = 'EXCMAGREEMENTCONSENT_DELETE_RESET'
export const EXCMAGREEMENTCONSENT_DELETE_SET_ERROR = 'EXCMAGREEMENTCONSENT_DELETE_SET_ERROR'
export const EXCMAGREEMENTCONSENT_DELETE_SET_DELETED = 'EXCMAGREEMENTCONSENT_DELETE_SET_DELETED'
export const EXCMAGREEMENTCONSENT_DELETE_TOGGLE_LOADING = 'EXCMAGREEMENTCONSENT_DELETE_TOGGLE_LOADING'
